import { api } from 'services/api'
import { CartPreviewData, CartPreviewRequest, ProductTiersData } from 'types/progressiveDiscountTypes'

export async function getProductTiers(productId: number): Promise<ProductTiersData> {
  const { data } = await api.get(`/progressive-discounts/product/${productId}`)
  return data.data
}

export async function getCartPreview(body: CartPreviewRequest, signal?: AbortSignal): Promise<CartPreviewData> {
  const { data } = await api.post('/progressive-discounts/cart/preview', body, { signal })
  return data.data
}
